// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1RZpC","col":"styles_col__27X0b"};